"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * A table cell component
 *
 * @displayName Td
 * @param {Object} props passed in properties
 * @returns {React.Element} Rendered Td
 * @extends React.Component
 */
var _default = props => /*#__PURE__*/_react.default.createElement("td", props);
exports.default = _default;